import { BLOCK_TYPES } from '../utils/constants';
import { DayBlockDTO, IDayBlockDTO } from './day-block';
import { IGradeUnitDayDTO } from './grade-unit/grade-unit-day';

export interface IEmbedBlock extends IDayBlockDTO {
  html: string;
}

export interface IEmbed {
  embed: string;
}
export class EmbedBlock extends DayBlockDTO implements IEmbedBlock {
  id: number;
  dayNumber: number;
  day: IGradeUnitDayDTO;
  html: string = '';
  blockType: BLOCK_TYPES = BLOCK_TYPES.EmbedBlock;
  position: number = 0;
  embed: any;

  constructor(configOverride?: Partial<IEmbedBlock>) {
    super();
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
